import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { IOTGPhotoData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';

export default class OTGPhoto {
  id: number | undefined;
  parrentType: string;
  title: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  imgUrl: string;
  dateCreated: number | string | undefined;
  galleryId: number | null;
  seoURL?: string;

  constructor() {
    this.id = undefined;
    this.parrentType = '';
    this.title = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.imgUrl = '';
    this.dateCreated = '';
    this.galleryId = null;
    this.seoURL = '';
  }

  static mappingObject(_obj: IOTGPhotoData): IContentItem {
    let obj = Object.assign(new OTGPhoto(), _obj);
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.imgUrl = _obj.ImgUrl ? _obj.ImgUrl : '';
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.galleryId = _obj.GalleryID || null;
    obj.seoURL = _obj.SEOUrl || '';

    obj = utils.cleanObjectKeys(Object.keys(new OTGPhoto()), obj);
    return obj;
  }

  static mappingObjects(_data: IOTGPhotoData[]): IContentItem[] {
    return _data.map(item => OTGPhoto.mappingObject(item));
  }
}
